import React from 'react';

// Components
import WpTextField from 'Wpds/components/text-field/WpTextField';

type Props = {
  updateFilters?: Function;
  value: string;
};

const NameFilter = ({ updateFilters, value }: Props) => {
  const handleChange = (value: string) => {
    if (updateFilters) {
      updateFilters({ name: value });
    }
  };

  const handleOnClear = () => {
    handleChange('');
  };

  const showOnClear = value !== '';

  return (
    <WpTextField
      id="surface-filter-text-input"
      label="Search SurfaceAI"
      labelHidden
      placeholder="Search SurfaceAI"
      prefixIcon="search"
      onChange={handleChange}
      value={value}
      onClear={showOnClear && handleOnClear}
    />
  );
};

export default NameFilter;
